import { render } from "./App.vue?vue&type=template&id=4a176a87"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Glenn\\Source\\GIT\\Giant.B2C\\Giant.Website\\vue-apps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__